import { useTranslation } from 'react-i18next'
import styles from './SyllabusHeader.module.scss'

const SyllabusHeader = ({ profile, me, syllabuses, activeSyllabus, setActiveSyllabus }) => {
  const { t } = useTranslation('common')
  return (
    <div className={`unv-card ${styles.header}`}>
      <div>
        <h1 className={styles.title}>{t('syllabus.view_title')}</h1>
        <div className={styles.muted}>
          {t('syllabus.student_inline', {
            name: profile?.full_name || me?.full_name || '—',
            group: profile?.group_name || profile?.group?.name || '—',
          })}
        </div>
      </div>
      <div className={styles.sylSelect}>
        <label>{t('syllabus.plan_label')}</label>
        <select
          className="unv-input"
          value={activeSyllabus || ''}
          onChange={(e) => setActiveSyllabus(Number(e.target.value))}
        >
          <option value="">{t('syllabus.select_plan_option')}</option>
          {syllabuses.map((s) => (
            <option key={s.id} value={s.id}>
              {s.name || s.title || t('syllabus.plan_default_name', { id: s.id })}
            </option>
          ))}
        </select>
      </div>
    </div>
  )
}

export default SyllabusHeader
